<template>
  <div id="main">
    <v-index>
      <el-breadcrumb separator="/">
        <el-breadcrumb-item>实训</el-breadcrumb-item>
        <el-breadcrumb-item><a style="color: #000000;">基地管理</a></el-breadcrumb-item>
      </el-breadcrumb>

      <v-weburl-iframe url="train/base/index" />
    </v-index>
  </div>
</template>

<script>
import VIndex from "@/components/common";
import VWeburlIframe from "@/components/weburl-iframe";
export default {
  name: 'TrainManage',
  components: {VWeburlIframe, VIndex}
}
</script>

<style scoped>

</style>
